import { Button, Container } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import { registerUserToDatabase } from '../../services/NewGroupService';
import { useState, useEffect } from 'react';

interface Props {
    message?: string;
}

const SendNotifications = (props: Props) => {
    const { message } = props;
    const [authorized, setAuthorized] = useState<any>(undefined);

    useEffect(() => {
        registerUserToDatabase().then((response: any) => {
            setAuthorized(response);
        })
    }, []);

    return (
        <Container>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <img style={{ color: '#d10000', width: '300px', height: '300px' }} alt="" src="/ColegioCervantes_ACUDE.png" />
                <h1 style={{ color: '#d10000', marginTop: '30px' }}>{message}</h1>
                <div style={{ marginTop: '30px' }}>
                    <Button variant="secondary" onClick={() => { firebase.auth().signOut(); }}> {authorized?.student ? "Log out" : "Cerrar sesión"}</Button>
                </div>
            </div>
        </Container>
    )
}

export default SendNotifications;
